/* eslint-disable default-param-last */
import { types, actions } from './actions'

const initialState: DonorRollState = {}

type SupportedActions = ActionsUnion<typeof actions>

export const reducer = (state: DonorRollState = initialState, action: SupportedActions): DonorRollState => {
    switch (action.type) {
        case types.ASSIGN_DONOR_ROLL_SETTINGS:
            return {
                ...state,
                instanceSettings: action.payload as DonorRollSettingsDto,
            }
        case types.POPULATE_DONOR_ROLL_DATA:
            return {
                ...state,
                data: action.payload as ApiDonorRollDataRecord[],
            }
        case types.TOGGLE_OVERRIDE_DISPLAY_LIMIT:
            return {
                ...state,
                overrideDisplayLimit: !state.overrideDisplayLimit,
            }
    }
    return state
}
